<template>
  <ContactUsSection ref="contactUs"></ContactUsSection>
</template>

<script>
  import ContactUsSection from "./ContactUsSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "ContactUsWrapper",
    components: {
      ContactUsSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
